module.exports = __webpack_public_path__ + "img/up.eb9e0e39.png";